import React from "react";
export const DialogContext = React.createContext({});
//# sourceMappingURL=context.js.map